import { makeStyles } from '@material-ui/core/styles';

export default  makeStyles({
    appContainer: {
      minHeight: '100vh',
      width: '100vw'
    },
  
    todosContainer: {
      marginTop: '150px',
      width: '45vw',
      maxWidth: '850px',
      minWidth: '300px'
    },
  
    toolbar: {
      maxWidth: '1800px'
    }
  });
  